package app.api

import app.client
import app.model.Project
import app.model.ProjectWithDependencies
import app.plugin.Routing
import dev.fritz2.core.RootStore
import io.ktor.client.call.*
import io.ktor.client.plugins.resources.*
import io.ktor.http.*
import kotlinx.coroutines.Job

class ProjectsApi : RootStore<List<ProjectWithDependencies>>(emptyList(), job = Job()) {
    val handler = handle {
        client.get(Routing.Projects.Dependencies()).body<List<ProjectWithDependencies>>().sortedBy { it.name }
    }

    val postProject = handle { projects, newProject: Pair<String, String> ->
        val project = client.post(
            Routing.Projects.New(
                name = newProject.first,
                description = newProject.second
            )
        ).body<Project>()
        projects + ProjectWithDependencies(
            id = project.id,
            name = project.name,
            description = project.description,
            companyProjects = emptyList()
        )
    }

    val deleteProject = handle { projects, id: Int ->
        val resp = client.delete(Routing.Projects.Id(id = id))
        require(resp.status == HttpStatusCode.NoContent)
        projects.filter { project -> project.id != id }
    }

    val postCompanyProject = handle { _, newProject: Pair<Int, String> ->
        val companyId = newProject.second.toInt()
        val resp = client.post(
            Routing.CompanyProjects.New(
                projectId = newProject.first,
                companyId = companyId
            )
        )
        require(resp.status == HttpStatusCode.Created)
        client.get(Routing.Projects.Dependencies()).body<List<ProjectWithDependencies>>()
    }

    val deleteCompanyProject = handle { _, id: Int ->
        val resp = client.delete(Routing.CompanyProjects.Id(id = id))
        require(resp.status == HttpStatusCode.NoContent)
        client.get(Routing.Projects.Dependencies()).body<List<ProjectWithDependencies>>()
    }

    val postCompanyProjectStage = handle { _, newProject: Pair<Int, String> ->
        val stageId = newProject.second.toInt()
        val resp = client.post(
            Routing.CompanyProjectStages.New(
                stageId = stageId,
                companyProjectId = newProject.first,
            )
        )
        require(resp.status == HttpStatusCode.Created)
        client.get(Routing.Projects.Dependencies()).body<List<ProjectWithDependencies>>()
    }

    val deleteCompanyProjectStage = handle { _, id: Int ->
        val resp = client.delete(Routing.CompanyProjectStages.Id(id = id))
        require(resp.status == HttpStatusCode.NoContent)
        client.get(Routing.Projects.Dependencies()).body<List<ProjectWithDependencies>>()
    }
}
